﻿import React, { useState, useEffect } from 'react';
import { IcDetector } from '../models/ic-detector';
import { FieldUpdate } from '../models/field-update';
import { CheckBox } from 'devextreme-react';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

export interface Props {
    benchSheetId: string;
    isReadOnly?: boolean;
}

export default function IcDetectorComponent(props: Props) {
    const [detector, setDetector] =
        useState<IcDetector>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        getAllData()
    }, [props.benchSheetId]);

    return (
        <div className="pw-content">
            <div className="analysis-checkbox-row">
                <CheckBox id="cations" text="Cations" readOnly={props.isReadOnly}
                    className="analysis-checkbox-row-item"
                    value={detector ? detector.cations : false}
                    onValueChanged={valueChanged} />

                <CheckBox id="anions" text="Anions" readOnly={props.isReadOnly}
                    className="analysis-checkbox-row-item"
                    value={detector ? detector.anions : false}
                    onValueChanged={valueChanged} />

                <CheckBox id="electromechanical" text="Electromechanical"
                    className="analysis-checkbox-row-item" readOnly={props.isReadOnly}
                    value={detector ? detector.electromechanical : false}
                    onValueChanged={valueChanged} />
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );


    function valueChanged(e: any) {
        if (!dataLoaded)
            return;

        if (detector && e.element && e.element.id) {
            const caller = e.element.id;

            let fieldUpdate: FieldUpdate = {
                entity: 'IcDetectors',
                field: caller,
                value: e.value,
                rowId: detector.icDetectorId
            };

            setDetector({ ...detector, [caller]: e.value });

            updateDetectorField(fieldUpdate)
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Detector");
                });
        }
    }

    async function getIcDetectorData() {
        await CrudFunctions.getData(`benchsheets/icdetectorbybenchsheetid/${props.benchSheetId}`)
            .then(data => {
                setDetector(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving IC DEtector Data");
            });
    }

    async function updateDetectorField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("benchsheets/icdetectorfield", fieldUpdate);
    }

    async function getAllData() {
        await getIcDetectorData()
            .then(() => setDataLoaded(true));
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
